import * as React from "react";
import styled from "styled-components";

interface WrapperProps {
  index: number;
}

const Wrapper = styled.section`
  width: 100%;
  height: 100%;
  transition: 700ms all ease;
  transform: translate3d(
    0px,
    ${(props: WrapperProps) => props.index * -100}%,
    0px
  );
`;

export interface ScrollContainerProps {
  index?: number;
  transitionEnd?: Function;
  data?: any;
  children?: React.ReactChild | any;
  [key: string]: any;
}

class ScrollContainer extends React.Component<ScrollContainerProps, {}> {
  private _wrapper: any;
  constructor(props: ScrollContainerProps) {
    super(props);
  }

  transitionEnd = (event: React.SyntheticEvent<HTMLElement>) => {
    if (event.target == this._wrapper) {
      this.props.transitionEnd();
    }
  };

  render() {
    return (
      <Wrapper
        index={this.props.index}
        innerRef={self => {
          this._wrapper = self;
        }}
        onTransitionEnd={this.transitionEnd}
      >
        {this.props.children}
      </Wrapper>
    );
  }
}

export default ScrollContainer;



// WEBPACK FOOTER //
// ./src/components/ScrollSection/ScrollContainer.tsx